import { date } from 'quasar';

export default {
    methods: {
        formatDate(...args) {
            return date.formatDate(...args)
        }
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/formatDate.js